import React, { Component } from 'react';
import axios from 'axios';


import {
  NavLink,
  Redirect
} from 'react-router-dom';


class CevaplarColchicum extends Component {

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      date: '',
      sunum01: [],
      sunum02: [],
      sunum03: [],
      sunum04: [],
      sunum05: [],
      sunum06: [],
      sunum07: [],
      sunum08: []
    }
  }

  componentDidMount() {
  
  const sonuc19 = 19;
  const sonuc24 = 24;
  const sonuc11 = 11;

    var uid = localStorage.getItem('uid');
    var auth = localStorage.getItem('auth');
  	const postId = location.pathname.split("/")[2];
  	//console.log(postId);
  
        var url01 = 'https://api.recordatifocus.com/colchicum-sonuc-01/' + postId;
        fetch(url01)
            .then(response01 => response01.json())
            .then(data01 => this.setState({
                sunum01: data01
            }));
        var url02 = 'https://api.recordatifocus.com/colchicum-sonuc-02/' + postId;
        fetch(url02)
            .then(response02 => response02.json())
            .then(data02 => this.setState({
                sunum02: data02
            }));
        var url03 = 'https://api.recordatifocus.com/colchicum-sonuc-03/' + postId;
        fetch(url03)
            .then(response03 => response03.json())
            .then(data03 => this.setState({
                sunum03: data03
            }));
        var url04 = 'https://api.recordatifocus.com/colchicum-sonuc-04/' + postId;
        fetch(url04)
            .then(response04 => response04.json())
            .then(data04 => this.setState({
                sunum04: data04
            }));
        var url05 = 'https://api.recordatifocus.com/colchicum-sonuc-05/' + postId;
        fetch(url05)
            .then(response05 => response05.json())
            .then(data05 => this.setState({
                sunum05: data05
            }));
  
        var url06 = 'https://api.recordatifocus.com/colchicum-sonuc-06/' + postId;
        fetch(url06)
            .then(response06 => response06.json())
            .then(data06 => this.setState({
                sunum06: data06
            }));
        var url07 = 'https://api.recordatifocus.com/colchicum-sonuc-07/' + postId;
        fetch(url07)
            .then(response07 => response07.json())
            .then(data07 => this.setState({
                sunum07: data07
            }));

        var url08 = 'https://api.recordatifocus.com/colchicum-sonuc-08/' + postId;
        fetch(url08)
            .then(response08 => response08.json())
            .then(data08 => this.setState({
                sunum08: data08
            }));

        }


        render() {
	// soru 01
                const {
                    sunum01
                } = this.state;
                let outputData01 = sunum01.map((item) => {
                    return {
                        cevap01: parseInt(item.cevap),
                    };
                });
                console.log("outputData01:", outputData01);
        
                const result01 = Object.values(outputData01).reduce(
                    (r, {
                        cevap01
                    }) => r + cevap01,0
                );
                console.log("result01:", result01);
        
        
                const longeur01 = sunum01.length;
                console.log("longeur01:", longeur01);
        
                let sonuc01 = 100 - (result01 * 100) / longeur01;
        
                console.log("Soru10 yanlis orani:", sonuc01);
        
        
	  // soru 02
                  const {
                    sunum02
                } = this.state;
                let outputData02 = sunum02.map((item) => {
                    return {
                        cevap02: parseInt(item.cevap),
                    };
                });
                const result02 = Object.values(outputData02).reduce(
                    (r, {
                        cevap02
                    }) => r + cevap02,
                    0
                );
        
                console.log("outputData02:", outputData02);
                console.log("result02:", result02);

        
                const longeur02 = sunum02.length;
                let sonuc02 = 100 - (result02 * 100) / longeur02;
                console.log("Soru02 yanlis orani:", sonuc02);
	  // soru 03
                  const {
                    sunum03
                } = this.state;
                let outputData03 = sunum03.map((item) => {
                    return {
                        cevap03: parseInt(item.cevap),
                    };
                });
                const result03 = Object.values(outputData03).reduce(
                    (r, {
                        cevap03
                    }) => r + cevap03,
                    0
                );
                const longeur03 = sunum03.length;
                let sonuc03 = 100 - (result03 * 100) / longeur03;
                console.log("Soru03 yanlis orani:", sonuc03);

	  // soru 04
                  const {
                    sunum04
                } = this.state;
                let outputData04 = sunum04.map((item) => {
                    return {
                        cevap04: parseInt(item.cevap),
                    };
                });
                const result04 = Object.values(outputData04).reduce(
                    (r, {
                        cevap04
                    }) => r + cevap04,
                    0
                );
                const longeur04 = sunum04.length;
                let sonuc04 = 100 - (result04 * 100) / longeur04;
                console.log("Soru04 yanlis orani:", sonuc04);

	  // soru 05
                  const {
                    sunum05
                } = this.state;
                let outputData05 = sunum05.map((item) => {
                    return {
                        cevap05: parseInt(item.cevap),
                    };
                });
                const result05 = Object.values(outputData05).reduce(
                    (r, {
                        cevap05
                    }) => r + cevap05,
                    0
                );
                const longeur05 = sunum05.length;
                let sonuc05 = 100 - (result05 * 100) / longeur05;
                console.log("Soru05 yanlis orani:", sonuc05);

	  // soru 06
                  const {
                    sunum06
                } = this.state;
                let outputData06 = sunum06.map((item) => {
                    return {
                        cevap06: parseInt(item.cevap),
                    };
                });
                const result06 = Object.values(outputData06).reduce(
                    (r, {
                        cevap06
                    }) => r + cevap06,
                    0
                );
                const longeur06 = sunum06.length;
                let sonuc06 = 100 - (result06 * 100) / longeur06;
                console.log("Soru06 yanlis orani:", sonuc06);

	  // soru 07
                  const {
                    sunum07
                } = this.state;
                let outputData07 = sunum07.map((item) => {
                    return {
                        cevap07: parseInt(item.cevap),
                    };
                });
                const result07 = Object.values(outputData07).reduce(
                    (r, {
                        cevap07
                    }) => r + cevap07,
                    0
                );
                const longeur07 = sunum07.length;
                let sonuc07 = 100 - (result07 * 100) / longeur07;
                console.log("Soru07 yanlis orani:", sonuc07);
 
	  // soru 08
                  const {
                    sunum08
                } = this.state;
                let outputData08 = sunum08.map((item) => {
                    return {
                        cevap08: parseInt(item.cevap),
                    };
                });
                const result08 = Object.values(outputData08).reduce(
                    (r, {
                        cevap08
                    }) => r + cevap08,
                    0
                );
                const longeur08 = sunum08.length;
                let sonuc08 = 100 - (result08 * 100) / longeur08;
                console.log("Soru08 yanlis orani:", sonuc08);
 
 
  
  
      var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {

    return (
    
    
    
      <div className="row pt-5">
          <div className="col-md-6">
              <div className="list-group">
                  <div className="list-group-item list-group-item-action list-group-item-success mb-1">Yanlis Cevap Yuzdesi</div>
              </div>
              <div className="list-group mb-3">
                  <br />
                  <div className="list-group-item list-group-item-action">
                      Soru 1 : {sonuc01.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 2 : {sonuc02.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 3 : {sonuc03.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 4 : {sonuc04.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 5 : {sonuc05.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 6 : {sonuc06.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 7 : {sonuc07.toFixed(2)}
                  </div>
                  <div className="list-group-item list-group-item-action">
                      Soru 8 : {sonuc08.toFixed(2)}
                  </div>
              </div>
          </div>


          <div className="col-md-6">
              <div className="list-group">
                  <div className="list-group-item list-group-item-action list-group-item-success mb-1">COLCHICUM Sorular ve Cevaplar</div>
              </div>
              <div className="list-group mb-3">
              
                  <div className="p-2">


                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">1. </span>
                                    <span class="fieldset-legend">Aşağıdakilerden hangisi Kolşisinin etki mekanizmasını tam olarak açıklar?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">İnflamazom aktivasyonunu inhibe eder &amp; Mikrotübül polimerizasyonunu inhibe eder.</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Anjiotensin dönüştürücü enzimi inhibe ederek anjiyotensin I' in anjiyotensin II ye dönüşümünü engellerler.</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Beta reseptörlere bağlanarak, stres hormonlarının bu reaksiyonu tetiklemesini önler. Böylece, kalp hızını yavaşlatarak ve kalp kaslarının kasılma gücünü (pompa işlevi) azaltarak kardiyak stresi azaltır.</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Kan damarlarının kasılmasına veya daralmasına neden olan kalsiyum iyonlarını bloke ederek kalbin iş yükünü azaltır</div>
                                    </div>
                                </div>
                            </div>




                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">2. </span>
                                    <span class="fieldset-legend">Aşağıdakilerden hangilerinin birlikte varlığı en yüksek mortalite ve KV Risk ile ilişkilidir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Düşük CRP , Düşük LDL-K</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Düşük CRP, Yüksek LDL-K</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Yüksek CRP, Düşük LDL-K</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">Yüksek CRP, Yüksek LDL-K</div>
                                    </div>
                                </div>
                            </div>




                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">3. </span>
                                    <span class="fieldset-legend">Stent İlişkisiz Akut miyokard enfarktüsü görülme olasılığını %25 azalma sağlandığı österilen kolşisin ile gerçekleştirilmiş çalışma aşağıdakilerden hangisidir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">LODOCO</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">LODOCO2</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">COLCOT</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Defteros</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">COPS</div>
                                    </div>
                                </div>
                            </div>



                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">4. </span>
                                    <span class="fieldset-legend">İskemi kaynaklı revaskülarizasyon sıklığında %25 azalma sağlandığı gösterilen kolşisin ile gerçekleştirilmiş çalışma aşağıdakilerden hangisidir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">LODOCO</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">LODOCO2</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">COLCOT</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Defteros</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">COPS</div>
                                    </div>
                                </div>
                            </div>



                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">5. </span>
                                    <span class="fieldset-legend">Miyokard infarktüsü sonrası ilk 3 gün içinde 0.5mg/gün kolşisin tedavisinin iskemik kardiyovasküler olay riskinde % 48 azalma sağladığını gösteren çalışma aşağıdakilerden hangisidir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">LODOCO</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">LODOCO2</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">COLCOT</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Defteros</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">COPS</div>
                                    </div>
                                </div>
                            </div>


                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">6. </span>
                                    <span class="fieldset-legend">Kolşisinin inme sıklığını %74 azalttığını gösteren çalışma aşağıdakilerden hangisidir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">LODOCO</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">LODOCO2</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">COLCOT</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Defteros</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">COPS</div>
                                    </div>
                                </div>
                            </div>


                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">7. </span>
                                    <span class="fieldset-legend">Çıplak Stent (Bare Metal Stent, BMS) ve perkütan koroner girişim uygulanmış olan diyabetik hastalarda 0.5 mg/gün kolşisin tedavisi ile stent içi restenoz sıklığında %52 azalma izlenen çalışma aşağıdakilerden hangisidir?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">LODOCO</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">LODOCO2</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">COLCOT</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">Defteros</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">COPS</div>
                                    </div>
                                </div>
                            </div>



                            <div class="border-bottom mb-3 pb-3">
                                <div id="edit-soru-1--wrapper-legend" class="fw-bold mb-3">
                                    <span class="field-prefix">8. </span>
                                    <span class="fieldset-legend"> Kolşisin tedavisi ile ilgili aşağıdaki önermelerden hangisi yanlıştır?</span>
                                </div>
                                <div class="fieldset-wrapper">
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Enfeksiyon sebebiyle hastaneye yatış riskinde artışa neden olmaz.</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Pnömoni sebebiyle hastaneye yatış riskinde artışa neden olmaz.</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Gastrointestinal problemler sebebiyle hastaneye yatış riskinde artışa neden olmaz.</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-white border-2">
                                        <div class="webform-element-description">Kanser gelişim riskinde artışa neden olmaz.</div>
                                    </div>
                                    <div class="rounded-3 p-2 mb-2 bg-dark-subtle border-2">
                                        <div class="webform-element-description">Mortalite riskinde anlamlı derecede artışa neden olur.</div>
                                    </div>
                                </div>
                            </div>







                  </div>
              
              </div>

          
          </div>




      </div>

    
    
    
    
    );
    } else {
        return (
          <div className="row top-buffer">
        	<Redirect to="/user/login" />
          </div>
        );
    }



  }
}

export default CevaplarColchicum



// WEBPACK FOOTER //
// src/components/cevaplar-colchicum.jsx